module.exports = __webpack_public_path__ + "static/img/15-2.4b2ed27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15-2.jpg
// module id = VAPZ
// module chunks = 0